import MessageAvatar from "./MessageAvatar";

export default MessageAvatar;
